import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FlagComponent } from './flag.component';

@NgModule({
  declarations: [
    FlagComponent
  ],
  imports: [
    CommonModule,
    NgbModule
  ],
  exports: [
    FlagComponent
  ]
})
export class FlagModule { }
